import style from '../yeah.module.scss'
import { InView } from "react-intersection-observer"
import animations from '@styles/animations.module.scss'
import { isLastIndex } from '../yeah.state'

interface ISolutionSectionProps {
    title: string;
    textArray: Array<string>;
}

const SolutionSectionYeah = ({ title, textArray }: ISolutionSectionProps) => {
    return (
        <section className={`${style.section} ${style.section_px80}`}>
            <div className={`${style.container} ${style.solution}`}>
                <InView triggerOnce={true}>
                    {({ inView, ref, entry }: any) => {
                        if (inView) {
                            entry?.target.classList.add(animations.active);
                        }
                        return (
                            <div ref={ref} className={`${style.title} ${style.title_large} ${style.solution__title} ${style.mr106} ${animations.scroll__animation}`}>
                                {title}
                            </div>
                        )
                    }}
                </InView>
                <div className={`${style.solution__items}`}>
                    {
                        textArray.map((text: string, index: number) => {
                            return (
                                <InView triggerOnce={true} key={index}>
                                    {({ inView, ref, entry }: any) => {
                                        if (inView) {
                                            entry?.target.classList.add(animations.active);
                                        }
                                        return (
                                            <div ref={ref} className={`${style.solution__item} ${animations.scroll__animation} ${style.text} ${style.text_middle} ${isLastIndex(index, textArray.length) ? null : style.mb16}`}>
                                                {text}
                                            </div>
                                        )
                                    }}
                                </InView>
                            )
                        })
                    }
                </div>
            </div>
        </section>
    )
}

export default SolutionSectionYeah;